/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FontFamilyEditing from './fontfamilyediting';
import FontFamilyUI from './fontfamilyui';

export default class FontFamily extends Plugin {
	static get requires() {
		return [ FontFamilyEditing, FontFamilyUI ];
	}

	static get pluginName() {
		return 'CustomFontFamily';
	}
}
